import { DynamicFormV2Palette } from "@mui/material";

export type FormRadioComponentTokenType = {
  textColor: string;
  borderColor: string;
  backgroundColor: string;
  hoverBackgroundColor: string;
  selectedBackgroundColor: string;
  selectedTextColor: string;
};

export const assignRadioComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    textColor: formsPalette.text.intense,
    borderColor: formsPalette.border.moderate,
    backgroundColor: formsPalette.surface.supershy,
    hoverBackgroundColor: formsPalette.surface.hover.quiet,
    selectedBackgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    selectedTextColor: formsPalette.text.reverse,
  } as FormRadioComponentTokenType;
};
